import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-t",
  "use": "icon-arrow-t-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-arrow-t\"><path d=\"M182.2473683 772.33102554l338.43033323-338.43033322L859.10803475 772.33102554a83.9133679 83.9133679 0 0 0 121.48781124 0 83.9133679 83.9133679 0 0 0 0-121.48781125l-399.17423984-399.17423983a83.9133679 83.9133679 0 0 0-121.48781126 0l-399.17423987 399.17423984A85.90923843 85.90923843 0 1 0 182.2473683 772.33102554z\" fill=\"#3B86FF\" p-id=\"2845\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol